/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * * `available` - Available
 * * `sick` - Sick
 * * `leave` - Leave
 * * `overtime` - Overtime
 */
export enum AvailabilityTypeEnum {
  AVAILABLE = 'available',
  SICK = 'sick',
  LEAVE = 'leave',
  OVERTIME = 'overtime',
}
